import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "h-full flex overflow-y-scroll scroll-hidden"
};
const _hoisted_2 = {
  class: "h-full flex flex-col gap-6 p-4"
};
const _hoisted_3 = {
  class: "flex flex-col gap-5"
};
const _hoisted_4 = {
  key: 0,
  class: "truncate px-2 font-semibold border-b border-main-50 pb-1"
};
const _hoisted_5 = {
  class: "flex flex-col gap-1 text-main-50 text-2xs mt-auto"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "h-full w-[90px] flex flex-col items-center gap-3 shrink-0 py-4",
  ref: "sidebar-menu-container"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "text-[9px] font-bold text-center"
};
const _hoisted_11 = {
  key: 1,
  class: "h-px w-2/3 bg-main-5"
};
const _hoisted_12 = {
  class: "w-full mt-auto animate-none! opacity-100! px-4"
};
const _hoisted_13 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SubscriptionCard = _resolveComponent("SubscriptionCard");
  return _openBlock(), _createElementBlock(_Fragment, null, [_cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "h-full lg:w-[90px] shrink-0",
    "focus-group": "navigation-menu-controller"
  }, null, -1)), _createElementVNode("div", {
    class: _normalizeClass(["absolute h-full max-w-full top-0 left-0 bg-main-100 text-main-5 transition-[width,left] duration-300 z-50", {
      'max-lg:left-[-90px]!': !_ctx.$state.navigationMenuOpen
    }]),
    "focus-group": "navigation-menu-controller"
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["flex flex-col transition-[width,opacity] duration-300 text-sm", [_ctx.$state.navigationMenuOpen ? 'w-[360px]' : 'w-0 opacity-0 pointer-events-none']])
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [this.currentUser?.userData ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(this.currentUser.userData.email), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    class: "truncate px-2 py-1 hover:bg-main-5/20 rounded cursor-pointer transition-[background]",
    onClick: _cache[0] || (_cache[0] = $event => {
      this.$router.push({
        name: 'UserProfile'
      });
      _ctx.$state.navigationMenuOpen = false;
    })
  }, _toDisplayString(_ctx.$st('app.account.name')), 1), !_ctx.$appConfig.hidden_routes?.includes('/payments') ? (_openBlock(), _createElementBlock("p", {
    key: 1,
    class: "truncate px-2 py-1 hover:bg-main-5/20 rounded cursor-pointer transition-[background]",
    onClick: _cache[1] || (_cache[1] = $event => {
      this.$router.push({
        name: 'Payments'
      });
      _ctx.$state.navigationMenuOpen = false;
    })
  }, _toDisplayString(_ctx.$st('app.payments.name')), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    class: "truncate px-2 py-1 hover:bg-main-5/20 rounded cursor-pointer transition-[background]",
    onClick: _cache[2] || (_cache[2] = $event => {
      $options.GetUpdateNotes();
      _ctx.$state.navigationMenuOpen = false;
    })
  }, " Novedades "), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "border-t border-dotted border-main-10"
  }, null, -1)), _createElementVNode("p", {
    class: "truncate px-2 py-1 hover:bg-main-5/20 rounded cursor-pointer transition-[background]",
    onClick: _cache[3] || (_cache[3] = $event => {
      this.user.logout();
      _ctx.$state.navigationMenuOpen = false;
    })
  }, _toDisplayString(_ctx.$st('app.logout')), 1)]), _createVNode(_component_SubscriptionCard, {
    class: "mt-auto self-center"
  }), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(_ctx.$store.getters.appVersion), 1), _ctx.$embedded ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Host " + _toDisplayString(_ctx.desktopVersion), 1)) : _createCommentVNode("", true)])])], 2), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.Items, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "w-full flex flex-col items-center"
    }, [item.type === 'button' ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["relative group h-[54px] w-16 flex flex-col items-center justify-center gap-1 rounded-md bg-main-5 shadow-material cursor-pointer text-main-100 select-none", {
        'selected-navigation-item': item.isActive?.()
      }]),
      onClick: $event => {
        item.onclick?.();
        _ctx.$state.navigationMenuOpen = false;
      }
    }, [item.icon ? (_openBlock(), _createElementBlock("i", {
      key: 0,
      class: _normalizeClass(["text-2xl", item.icon])
    }, null, 2)) : _createCommentVNode("", true), item.image ? (_openBlock(), _createElementBlock("img", {
      key: 1,
      src: item.image,
      class: "h-[24px]",
      alt: ""
    }, null, 8, _hoisted_9)) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_10, _toDisplayString(this.$st(item.label)), 1), _createElementVNode("div", {
      class: _normalizeClass(["absolute right-[calc(100%+6px)] h-3 w-1 scale-0 opacity-0 group-hover:scale-100 group-hover:opacity-100 bg-main-5 shrink-0 rounded-xl transition-[height,transform,opacity] duration-300 animate-fade", {
        'h-8! scale-100! opacity-100!': item.isActive?.()
      }])
    }, null, 2)], 10, _hoisted_8)) : item.type === 'separator' ? (_openBlock(), _createElementBlock("div", _hoisted_11)) : _createCommentVNode("", true)]);
  }), 128)), _createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
    src: _ctx.$appConfig.logotype_white || require('@/assets/icons/slango-logotype-vertical-white.svg'),
    class: "w-full"
  }, null, 8, _hoisted_13)])], 512)])], 2)], 64);
}